/**
 * @format
 */

import { AppRegistry } from "react-native";
import AppWrappedWithStore from "./App";
import { name as appName } from "./app.json";
import React from "react";
import { globalImport } from "./src/common/globalImports";

export const REACT_APP_ENV = globalImport?.REACT_APP_ENV
  ? globalImport?.REACT_APP_ENV
  : "dev";
export const isLogEnabled = true;

if (!globalImport.isWeb) {
  globalImport?.sentry?.init({
    dsn: "https://7c0990c62dd543b88c9c81197f3f2512@o4503918337327104.ingest.sentry.io/4505172605992960",
    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
    // We recommend adjusting this value in production.
    tracesSampleRate: 1.0,
    environment: REACT_APP_ENV,
  });
} else {
  if (REACT_APP_ENV === "prod") {
    globalImport?.sentry?.init({
      dsn: "https://6824a36c584a4949a8cdf8b429bffc3d@o4503918337327104.ingest.sentry.io/4503918341259267",
      integrations: [new globalImport.BrowserTracing()],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    });
  }
}

function HeadlessCheck({ isHeadless }) {
  if (isHeadless) {
    // App has been launched in the background by iOS, ignore
    return null;
  }

  return <AppWrappedWithStore />;
}

function App() {
  // Your application
}

AppRegistry.registerComponent(appName, () => HeadlessCheck);
